import React from 'react'
import "./AppliedFilterCard.scss";
import { Pencil, TrashCan } from '@livingdesign/icons';
import { formatFilterToRender, mapAttributeToLabel } from '../../../../../../../utils/recipientUtils';
import { IconButton } from '@livingdesign/react';

export const QA_ID_PREFIX = "AppliedFilterCard";

function AppliedFilterCard({
  parsedFilter = [],
  handlEditFilter: handleEditFilterProp,
  loading,
  handleDeleteFilter,
}) {

  const renderFilter = () => {
  const filters = formatFilterToRender(parsedFilter);
  return (
    filters.map((filter, index) => (
        <div
          key={index}
          className='filter-row'
          style={{ margin: "16px 0" }}
          data-testid={`${QA_ID_PREFIX}-filter-row-${index}`}
        >
          <span
            className='filter-attribute-column'
            data-testid={`${QA_ID_PREFIX}-filter-attribute-column-${index}`}
          >
            { mapAttributeToLabel(filter["attribute"])}:&nbsp;
          </span>
          <span
            className='filter-values-column'
            data-testid={`${QA_ID_PREFIX}-filter-values-column-${index}`}
          >
            {filter["values"]?.map((value, valIndex) => (
              <span
                key={valIndex}
                className='filter-value-item'
                data-testid={`${QA_ID_PREFIX}-filter-value-item-${index}-${valIndex}`}
              >
                {value}
              </span>
            ))}
          </span>
          &nbsp;
          {filter["operator"] && (
            <span
            className='filter-operator-column'
            data-testid={`${QA_ID_PREFIX}-filter-operator-column-${index}`}
            >
            {filter["operator"]}
            </span>
          )}
        </div>
      ))
  )
  }

  const handleEditFilter = () => {
  if (!loading && handleEditFilterProp) {
    handleEditFilterProp();
  }
  };

  return (
  <div className="applied-filter-card" data-testid={`${QA_ID_PREFIX}-card`}>
    <div className='applied-filter-header' data-testid={`${QA_ID_PREFIX}-header`}>
      <h2 data-testid={`${QA_ID_PREFIX}-title`}>Applied filters</h2>
      <div
        className={`edit-filters-link ${loading ? 'disabled' : ''}`}
        onClick={handleEditFilter}
        data-testid={`${QA_ID_PREFIX}-edit-filters-link`}
      >
        <Pencil size='small' />&nbsp;&nbsp;Edit filters
      </div>
    </div>
    <div className='applied-filter-body' data-testid={`${QA_ID_PREFIX}-body`}>
    {
      renderFilter()
    }
    </div>
    <div
      style={{display: 'flex', justifyContent: 'space-between'}}
      data-testid={`${QA_ID_PREFIX}-footer`}
    >
      <div data-testid={`${QA_ID_PREFIX}-footer-left`}></div>
      <IconButton
      a11yLabel='delete-applied-filter'
      onClick={handleDeleteFilter || (() => {})}
      data-testid={`${QA_ID_PREFIX}-delete-button`}
      >
      <TrashCan size='small' />
      </IconButton>
    </div>
  </div>
  )
}

export default AppliedFilterCard;